import * as React from "react";
import {useEffect} from "react";
import {Button, Loading} from "web-com";
import {ContainerBox} from "myshubhlife-component/container-box";
import InsuranceBanner from "InsuranceV2/LandingPage/InsuranceBanner";
import {COLOR} from "utils/variables";
import {RouteComponentProps} from "react-router-dom";
import "InsuranceV2/LandingPage/styles.scss";
import {routePaths} from "InsuranceV2/routes";
import {history} from "load/store";
import {redirectToRiskcovry} from "InsuranceV2";
import {IActiveInsuranceList} from "InsuranceV2/ActiveInsurances";

interface IProps {
    link: string;
    insuranceList: IActiveInsuranceList[];
}

const LandingPage = (props: IProps & RouteComponentProps) => {
    const handleMyInsuranceClick = () => {
        history.push({
            pathname: `${props.match.url}/${routePaths.ACTIVE_INSURANCE}`});
    };
    useEffect(() => {
        !props.insuranceList.length && props.link && redirectToRiskcovry(props.link);
    }, [props]);
    return (
      <>
        <Loading active={!props.insuranceList.length}/>
        <ContainerBox backgroundColor={COLOR.WHITE}>
                <div className="riskcovry-container">
                    <InsuranceBanner redirectLink={props.link} />
                    <div className="buttons-container">
                        <Button
                            buttonText="My Insurance"
                            maxWidth="100%"
                            width="100%"
                            height="42px"
                            onClick={handleMyInsuranceClick}
                        />
                        <div className="product">
                            <Button
                                buttonText="Explore!"
                                onClick={() => redirectToRiskcovry(props.link)}
                                maxWidth="100%"
                                width="100%"
                                height="42px"
                                bgColor={COLOR.BUTTON_GREEN}
                                />
                            <div className="ribbon-wrapper">
                                <div className="ribbon">New</div>
                            </div>
                        </div>
                    </div>
                </div>
        </ContainerBox>
      </>
    );
};

export default LandingPage;
